import { render, staticRenderFns } from "./servicesBox.vue?vue&type=template&id=0a043bee"
import script from "./servicesBox.vue?vue&type=script&lang=js"
export * from "./servicesBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports